export default "__VITE_ASSET__P9UiSJLN__"